import React from 'react';
import {render} from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import store from './store';
import {App} from './components/App';
import './main.css';

import registerServiceWorker from './registerServiceWorker';

render(
    <Provider store={store}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Provider>,
    document.getElementById('root')
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js